<template>
    <div>
        <el-card>
            <div style="width:60%;">
                <div v-for="(item,index) in hotFAQ" :key="index">
                    <div class="knowledgeMesBox">
                        <router-link :to="{ path: '/knowledgeDetail',
                                        query:{message:item} }">
                            <el-button class="titleLeft" type="text">{{item.Title}}</el-button>
                        </router-link>
                        <div class="contentHeight">
                            <p v-html="item.Body">{{item.Body}}</p>
                        </div>
                        <div class="bottomMessage">
                            <span>{{item.CreateTime}}</span>
                            <span>{{item.CreateUser}}</span>
                            <span>浏览次数:{{item.ViewCount}}</span>
                            <span>来源:{{item.Origin | tableVal(knowledgeDic)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
    import services from "../../services/common.service"
    export default {
        props:{
            // query:String,
            hotFAQ:Array
        },
        data: function () {
            return {
                // hotFAQ:[],
            }
        },
        mounted() {
            // this.search();
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            //知识来源
            knowledgeDic(){
                return this.dictionary.KnowledgeOrigin;
            },
        },
        methods:{
            // search(){//默认查询
            //     services.getList({"Query":this.query,"pageIndex":1,"pageSize":5}).then(res=>{
            //         this.hotFAQ = res.KnowledgeTable;
            //     })
            // },
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .titleLeft{
        font-size: 20px;
    }
    .contentHeight{
        height: 30px;
        overflow: hidden;
    }
    .knowledgeMesBox{
        border-bottom: 1px solid #C4C4C4;
    }
    .bottomMessage{
        margin-bottom: 3px;
        color: #C4C4C4;
        &>span{
            margin-right: 15px;
        }
    }
</style>
